import { render } from "./AvatarFieldComponent.vue?vue&type=template&id=166ac2c6"
import script from "./AvatarFieldComponent.vue?vue&type=script&lang=js"
export * from "./AvatarFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__